import { createContext } from "react";

export const SignupContext = createContext({});
